<template>
  <div class="komoditas">
               
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

       <v-flex lg12 sm6 xs12>
          <mini-statistic
            v-if="status==='konfirmasi' && komoditasPesananPengirimanStatus==='true'"
            head="Status"
            icon="fas fa-sync-alt"
            sub-title='Sedang Diproses'
            color="success"      
          >
          </mini-statistic>  
          <mini-statistic
            v-if="status==='konfirmasi' && komoditasPesananPengirimanStatus!=='true'"
            head="Status"
            icon="fas fa-check"
            sub-title="Kontrak Dikonfirmasi"
            color="success"      
          >
          </mini-statistic>  
          <mini-statistic
            v-if="status==='tolak'"
            head="Status"
            icon="fas fa-times"
            sub-title="Kontrak Ditolak"
            color="error"      
          >
          </mini-statistic>  
          <mini-statistic
            v-if="status!=='konfirmasi' && status!=='tolak'"
            head="Status"
            icon="fas fa-question"
            sub-title="Menunggu Jawaban"
            color="warning"      
          >
          </mini-statistic>  
        </v-flex>

        <!-- <v-flex lg6 sm6 xs12>
          <h5 class="text-xs-center">Permintaan Konfirmasi Kontak</h5>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="error" @click="tolakPermintaan">Tolak</v-btn>
            <v-btn color="success" @click="terimaPermintaan">Terima</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-flex>    -->

        <v-flex v-if="status==='konfirmasi' || status==='tolak'" lg4 sm6 xs12>
          <v-card v-if="status!=='konfirmasi'">
            <v-container>
              <h5 class="text-xs-center">No. Kontrak</h5>
              <h4 class="text-xs-center"><b>K1920-{{kodePenjualan}}</b></h4>
            </v-container>
          </v-card>
          <v-card v-if="status==='konfirmasi'">
            <v-container>
              <h5 class="text-xs-center">No. Kontrak</h5>
              <h4 class="text-xs-center"><b>K1920-{{kodePenjualan}}</b></h4>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex v-if="status==='konfirmasi' || status==='tolak'" lg4 sm6 xs12>
          <v-card v-if="status!=='konfirmasi'">
            <v-container>
              <h5 class="text-xs-center">Kode Penjualan</h5>
              <h4 class="text-xs-center"><b>{{kodePenjualan}}</b></h4>
            </v-container>
          </v-card>
          <v-card v-if="status==='konfirmasi'">
            <v-container>
              <h5 class="text-xs-center">Kode Penjualan</h5>
              <h4 class="text-xs-center"><b>{{kodePenjualan}}</b></h4>
            </v-container>
          </v-card>
        </v-flex>
             
        <v-flex v-if="status==='konfirmasi' || status==='tolak'" lg4 sm6 xs12>
          <v-card v-if="status!=='konfirmasi'">
            <v-container>
              <h5 class="text-xs-center">Kuantitas</h5>
              <h4 class="text-xs-center"><b>{{kuantitas}}.00 {{unitKuantitas}}</b></h4>
            </v-container>
          </v-card>
          <v-card v-if="status==='konfirmasi'">
            <v-container>
              <h5 class="text-xs-center">Kuantitas</h5>
              <h4 class="text-xs-center"><b>{{kuantitas}}.00 {{unitKuantitas}}</b></h4>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <vue-perfect-scrollbar class="chat-history--scrollbar">
        <v-divider></v-divider>
        <v-list two-line class="chat-contact--list">

        <!-- Table Start -->

        <v-flex v-if="komoditasPesananPengirimanStatus === 'false'" lg12 md12>
            <v-toolbar card color="white">
            <v-text-field
            flat
            solo
            prepend-icon="search"
            placeholder="Type something"
            v-model="search"
            hide-details
            class="hidden-sm-and-down"
            ></v-text-field>

            <v-btn color="primary" form="tambahkan-promosi" @click="gotoTambahkanPesananPengiriman"><v-icon>add</v-icon>Tambahkan Pesanan Pengiriman</v-btn>
        
            </v-toolbar>
    
            <v-divider></v-divider>
    
            <v-data-table
            :headers="complex.headers"
            :search="search"
            class="elevation-1 data-fonts"
            >
            <template>
                <td class="data-fonts"></td>
                <td class="data-fonts"></td>
                <td class="data-fonts"></td>
                <td class="data-fonts"></td>
                <td class="data-fonts"></td>
                <td class="data-fonts">-</td>
                <td class="data-fonts"></td>
                <td class="data-fonts"></td>
            </template>
            </v-data-table>
        </v-flex>  

        <!-- Table End -->

        <!-- Table Start -->

        <v-flex v-else lg12 md12>
            <v-toolbar card color="white">
            <v-text-field
            flat
            solo
            prepend-icon="search"
            placeholder="Type something"
            v-model="search"
            hide-details
            class="hidden-sm-and-down"
            ></v-text-field>

            <v-btn color="primary" form="tambahkan-promosi" @click="gotoTambahkanPesananPengiriman"><v-icon>add</v-icon>Tambahkan Pesanan Pengiriman</v-btn>
        
            </v-toolbar>
    
            <v-divider></v-divider>
    
            <v-data-table
            :headers="complex.headers"
            :search="search"
            :items="complex.items"
            class="elevation-1 data-fonts"
            >
            <template slot="items" slot-scope="props">
                <td class="data-fonts">{{ props.item.kodePenjualan }}</td>
                <td class="data-fonts">{{ props.item.statusPesanan }}</td>
                <td class="data-fonts">{{ props.item.pelanggan }}</td>
                <td class="data-fonts">{{ props.item.penyediaJasaPengiriman }}</td>
                <td class="data-fonts">{{ props.item.tanggalMulaiPengiriman }}</td>
                <td class="data-fonts">{{ props.item.pengirim }}</td>
                <td class="data-fonts">{{ props.item.lokasiPenjemputan }}</td>
                <td class="data-fonts">{{ props.item.penerima }}</td>
                <td class="data-fonts">{{ props.item.lokasiPengiriman }}</td>
                <td class="data-fonts">{{ props.item.komoditas }}</td>
                <td class="data-fonts">{{ props.item.kuantitas }} {{unitKuantitas}}</td>
                <td class="data-fonts">{{ props.item.dibuatPada }}</td>
            </template>
            </v-data-table>
        </v-flex>  

        <!-- Table End -->

        </v-list>  
    </vue-perfect-scrollbar> 
    
  </div>
</template>

<script>
// import { getPerusahaan } from '@/api/perusahaan';
// import { Items as Users } from '@/api/perusahaan';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import moment from 'moment'

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget,
    MiniStatistic
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',

      // Bagian Umum 
      kodePenjualan: localStorage.kontrakKodePenjualan,
      komoditas: localStorage.kontrakKomoditas,
      dokumen: localStorage.kontrakDokumen,

      // Pelaku Usaha
      penjual: localStorage.kontrakPenjual,
      entitasPenjual: localStorage.kontrakEntitasPenjual,
      kontakPenjual: localStorage.kontrakKontakPenjual,
      emailPenjual: localStorage.kontrakEmailPenjual,
      faxPenjual: localStorage.kontrakFaxPenjual,
      alamatJalanPenjual: localStorage.kontrakAlamatJalanPenjual,
      alamatKelurahanPenjual: localStorage.kontrakAlamatKelurahanPenjual,
      alamatKecamatanPenjual: localStorage.kontrakAlamatKecamatanPenjual,
      alamatKabupatenPenjual: localStorage.kontrakAlamatKabupatenPenjual,
      alamatKotaPenjual: localStorage.kontrakAlamatKotaPenjual,
      alamatProvinsiPenjual: localStorage.kontrakAlamatProvinsiPenjual,
      alamatKodePosPenjual: localStorage.kontrakAlamatKodePosPenjual,

      pembeli: localStorage.kontrakPembeli,
      entitasPembeli: localStorage.kontrakEntitasPembeli,
      kontakPembeli: localStorage.kontrakKontakPembeli,
      emailPembeli: localStorage.kontrakEmailPembeli,
      faxPembeli: localStorage.kontrakFaxPembeli,
      alamatJalanPembeli: localStorage.kontrakAlamatJalanPembeli,
      alamatKelurahanPembeli: localStorage.kontrakAlamatKelurahanPembeli,
      alamatKecamatanPembeli: localStorage.kontrakAlamatKecamatanPembeli,
      alamatKabupatenPembeli: localStorage.kontrakAlamatKabupatenPembeli,
      alamatKotaPembeli: localStorage.kontrakAlamatKotaPembeli,
      alamatProvinsiPembeli: localStorage.kontrakAlamatProvinsiPembeli,
      alamatKodePosPembeli: localStorage.kontrakAlamatKodePosPembeli,

      // Penjelasan Kontrak
      jenisKontrak: localStorage.kontrakJenisKontrak,
      kuantitas: localStorage.kontrakKuantitas,
      unitKuantitas: localStorage.kontrakUnitKuantitas,
      kualitas: localStorage.kontrakKualitas,
      hargaKomoditas: localStorage.kontrakHargaKomoditas,
      tempatPembayaran: localStorage.kontrakTempatPembayaran,
      musim: localStorage.kontrakMusim,
      jalurPengiriman: localStorage.kontrakJalurPengiriman,
      skalaPembayaran: localStorage.kontrakSkalaPembayaran,
      batasTanggalPembayaran: localStorage.kontrakBatasTanggalPembayaran,
      batasWaktuPembayaran: localStorage.kontrakBatasWaktuPembayaran,
      toleransi: localStorage.kontrakToleransi,
      daerahPemasaran: localStorage.kontrakDaerahPemasaran,
      provinsiPemasaran: localStorage.kontrakProvinsiPemasaran, 

      // Rincian Pengiriman
      pengirim: localStorage.kontrakPengirim,
      kontakPengirim: localStorage.kontrakKontakPengirim,
      lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
      alamatJalanPenjemputan: localStorage.kontrakAlamatJalanPenjemputan,
      alamatKelurahanPenjemputan: localStorage.kontrakAlamatKelurahanPenjemputan,
      alamatKecamatanPenjemputan: localStorage.kontrakAlamatKecamatanPenjemputan,
      alamatKabupatenPenjemputan: localStorage.kontrakAlamatKabupatenPenjemputan,
      alamatKotaPenjemputan: localStorage.kontrakAlamatKotaPenjemputan,
      alamatProvinsiPenjemputan: localStorage.kontrakAlamatProvinsiPenjemputan,
      alamatKodePosPenjemputan: localStorage.kontrakAlamatKodePosPenjemputan,

      penerima: localStorage.kontrakPenerima,
      kontakPenerima: localStorage.kontrakKontakPenerima,
      lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
      alamatJalanPengiriman: localStorage.kontrakAlamatJalanPengiriman,
      alamatKelurahanPengiriman: localStorage.kontrakAlamatKelurahanPengiriman,
      alamatKecamatanPengiriman: localStorage.kontrakAlamatKecamatanPengiriman,
      alamatKabupatenPengiriman: localStorage.kontrakAlamatKabupatenPengiriman,
      alamatKotaPengiriman: localStorage.kontrakAlamatKotaPengiriman,
      alamatProvinsiPengiriman: localStorage.kontrakAlamatProvinsiPengiriman,  
      alamatKodePosPengiriman: localStorage.kontrakAlamatKodePosPengiriman,

      // Detail Pengiriman
      tanggalMulaiPengiriman: localStorage.kontrakTanggalMulaiPengiriman,
      waktuMulaiPengiriman: localStorage.kontrakWaktuMulaiPengiriman,
      tanggalBerakhirPengiriman: localStorage.kontrakTanggalBerakhirPengiriman,
      waktuBerakhirPengiriman: localStorage.kontrakWaktuBerakhirPengiriman,

      // Penjelasan Barang
      jenisPengepakan: localStorage.kontrakJenisPengepakan,

      // Kondisi Kontrak
      kondisiUmum: localStorage.kontrakKondisiUmum,
      kondisiKhusus: localStorage.kontrakKondisiKhusus,

      // Penilaian Kontrak
      nilai: localStorage.kontrakNilai,
      maxNilai: localStorage.kontrakMaxNilai,
      tanggalJatuhTempo: localStorage.kontrakTanggalJatuhTempo,
      waktuJatuhTempo: localStorage.kontrakWaktuJatuhTempo,

      // Usaha Pedagang Perantara
      jenisPembayaran: localStorage.kontrakJenisPembayaran,

      // Administrasi
      invoicing: localStorage.kontrakInvoicing,
      perantara: localStorage.kontrakPerantara,
      entitasPerantara: localStorage.kontrakEntitasPerantara,
      kontakPerantara: localStorage.kontrakKontakPerantara,
      catatanPedagang: localStorage.kontrakCatatanPedagang,

      // Sistem
      kontrakAktif: localStorage.kontrakActiveCurrentDate,
      kontrakId: localStorage.kontrakID,
      komoditasPesananPengirimanStatus: localStorage.komoditasPesananPengiriman,  
      komoditasPesananPengirimanAktif: localStorage.komoditasPesananPengirimanAktif,
      komoditasPesananPengirimanID: localStorage.komoditasPesananPengirimanID,

      // Komoditas
      jenisPengirimanPesanan: localStorage.komoditasJenisPengirimanPesanan,
      penyediaJasaPengiriman: localStorage.komoditasPenyediaJasaPengiriman,
      kontakPenyediaJasaPengiriman: localStorage.komoditasKontakPenyediaJasaPengiriman,
      tanggalMulaiPenjemputan: localStorage.komoditasTanggalMulaiPenjemputan,
      waktuMulaiPenjemputan: localStorage.komoditasWaktuMulaiPenjemputan,
      kodePenjualanPenjemputan: localStorage.komoditasKodePenjualanPenjemputan,
      kodePenjualanPengiriman: localStorage.komoditasKodePenjualanPengiriman,
      faktur: localStorage.komoditasFaktur,
      jarakTempuh: localStorage.komoditasJarakTempuh,
      waktuTempuh: localStorage.komoditasWaktuTempuh,
      nilaiKomisi: localStorage.komoditasNilaiKomisi,

      complex: {
        selected: [],
        headers: [
          {
            text: 'Kode Penjualan',
            value: 'kodePenjualan'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            text: 'Pelanggan',
            value: 'pelanggan'
          },
          {
            text: 'Penyedia Pengiriman',
            value: 'penyediaJasaPengiriman'
          },
          {
            text: 'Tanggal Berlaku',
            value: 'tanggalBerlaku'
          },
          {
            text: 'Pengirim',
            value: 'pengirim'
          },
          {
            text: 'Penjemputan',
            value: 'penjemputan'
          },
          {
            text: 'Penerima',
            value: 'penerima'
          },
          {
            text: 'Pengiriman',
            value: 'pengiriman'
          },
          {
            text: 'Komoditas',
            value: 'komoditas'
          },
          {
            text: 'Kuantitas',
            value: 'kuantitas'
          },
          {
            text: 'Dibuat Pada',
            value: 'dibuatPada'
          },
        ],

        items:
        [
            {
                id: localStorage.komoditasPesananPengirimanID,
                kodePenjualan: localStorage.kontrakKodePenjualan,
                statusPesanan: localStorage.komoditasStatus,
                pelanggan: localStorage.kontrakPembeli,
                penyediaJasaPengiriman: localStorage.komoditasPenyediaJasaPengiriman,
                tanggalMulaiPengiriman: localStorage.kontrakTanggalMulaiPengiriman,
                pengirim: localStorage.kontrakPengirim,
                lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
                penerima: localStorage.kontrakPenerima,
                lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
                komoditas: localStorage.kontrakKomoditas,
                kuantitas: localStorage.kontrakKuantitas,
                dibuatPada: localStorage.komoditasPesananPengirimanAktif,

            },
        ],
      },

    };
  },

  computed: {
    // users () {
    //   return getPerusahaan();
    // },

    status() {
      return localStorage.komoditasStatus;
    },

  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    gotoTambahkanPesananPengiriman(){
      window.getApp.$emit('APP_TAMBAHKAN_PESANAN_PENGIRIMAN_KOMODITAS');
    },

    detailPesananPengiriman(){
        console.log("Cek Detail")
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    }    
  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 1em;
  }

  .border{
    border-bottom: 1px solid;
  }

  .sub-border{
    border-left: 1px solid;   
    padding-left: 1vw; 
  }

</style>
